export default __webpack_public_path__ + "static/Row 3.2_Dunman Sec-15bc334ae5a1bea6e447ffaf2b605a93.jpg";